import React, { useState } from 'react';
import '../Payment.scss';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import Dialog from '@mui/material/Dialog';
import { Icons } from '@Assets/SvgIcons';
import Button from '@mui/material/Button';
import { useAppSelector } from '@Store/hooks';
import { getUserDealspaceList } from '@Store/feature/dealspaceSlice';
import { RouteEnums } from '@Helper/Enums';
import { dealspaceUserIsOwner } from '@Helper/utils';

type IProps = {
  isUserImo: boolean;
};

const TrialLimitButton = ({ isUserImo }: IProps) => {
  let navigate = useNavigate();
  const { id } = useParams();

  const goPaymentAccount = () => {
    navigate(RouteEnums.WorkstreamPlan, { state: { dealspaceId: id } });
  };

  return (
    <React.Fragment>
      <button
        className="trial-limit-button"
        onClick={() => {
          if (isUserImo) {
            goPaymentAccount();
          }
        }}
      >
        <Icons.CurrencyExchange color="#FF7452" width="18" height="18" />{' '}
        <span style={{ marginLeft: 5 }}>
          Trial expired. Subscribe to continue
        </span>
      </button>
    </React.Fragment>
  );
};

export default TrialLimitButton;
